/* eslint-disable */
import { useContext, useEffect, useState } from 'react'
import '../../globalStyle.scss'
import { Button, Paper, Switch, Typography } from '@mui/material'
import { useApiGet, useApiPost } from '../../apiCalls/useApi'
import { getAdminManagedUsers, setUserStatus } from '../../apiCalls/permissionApi'
import RiskIntelligenceDataGrid from '../../components/RiskIntelligenceDataGrid'
import UserPermissionDetailDialog from './UserPermissionDetailDialog'
import CreateUserDialog from './CreateUserDialog'
import { ConfirmContext } from '../../Confirm'

export default function UsersList() {
  const fetchAdminManagedUsers = useApiGet(getAdminManagedUsers)
  const setUserActiveStatus = useApiPost(setUserStatus)
  const { openConfirm, closeConfirm, setConfirmSettings } = useContext(ConfirmContext)
  const [users, setUsers] = useState<any>([])
  const [data, setData] = useState<any>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [openManageDialog, setOpenManageDialog] = useState<boolean>(false)
  const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false)
  const [selectedUser, setSelectedUser] = useState<any>(null)
  const [saveClickedUpdate, setSaveClickUpdate] = useState<number>(0)
  useEffect(() => {
    setIsLoading(true)
    fetchAdminManagedUsers().then((res: any) => {
      if (!res || !res.users) {
        setUsers([])
        setIsLoading(false)
        return
      }
      setData(res.users)
      const processedUsers = res.users.map((item: any) => {
        return {
          id: item.id,
          email: item.email,
          firstname: item.firstname,
          lastname: item.lastname,
          phonenumber: item.phonenumber,
          status: item.isActive,
        }
      })
      setUsers(processedUsers)
      setIsLoading(false)
    })
  }, [saveClickedUpdate])

  const handleStatusChange = (userId: string, isActive: boolean, row: any) => {
    openConfirm()
    const te = `Switch ${row.firstname} ${row.lastname} (${row.email}) status to ${
      isActive ? 'inactive' : 'active'
    }.`
    setConfirmSettings({
      text: te,
      confirmCallback: async () => {
        handleSwitch(userId, isActive)
      },
    })
  }

  const handleSwitch = async (userId: string, isActive: boolean) => {
    const changeStatusErr = await setUserActiveStatus({ isActive: !isActive, userId })
    if (changeStatusErr) return
    const changedUsers = users.map((e: any) => {
      if (e.id === userId) {
        return { ...e, status: !isActive }
      }
      return { ...e }
    })
    setUsers(changedUsers)
    closeConfirm()
  }

  const handleEmailClick = (id: string) => {
    const user = data.find((user: any) => user.id === id)
    if (user) {
      setSelectedUser(user)
      setOpenManageDialog(true)
    }
  }

  const onManageClose = () => {
    setOpenManageDialog(false)
  }

  const columns = [
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      renderCell: (params: any) => (
        <div onClick={() => handleEmailClick(params.row.id)} className='linkStyle'>
          {params.value}
        </div>
      ),
    },
    {
      field: 'firstname',
      headerName: 'First Name',
      flex: 1,
    },
    {
      field: 'lastname',
      headerName: 'Last Name',
      flex: 1,
    },
    {
      field: 'phonenumber',
      headerName: 'Phone Number',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant='body2' color='textSecondary' style={{ marginRight: 8 }}>
            Inactive
          </Typography>
          <Switch
            checked={params.value}
            onChange={() => {
              handleStatusChange(params.row.id, params.value, params.row)
            }}
          />
          <Typography variant='body2' color='textSecondary' style={{ marginLeft: 8 }}>
            Active
          </Typography>
        </div>
      ),
    },
  ]
  return (
    <Paper square elevation={0} className='paperStyle'>
      <div style={{ height: 'calc(100% - 40px)' }}>
        <Button
          variant='contained'
          onClick={() => {
            setOpenCreateDialog(true)
          }}
        >
          Create User
        </Button>
        <RiskIntelligenceDataGrid rows={users} columns={columns} isLoading={isLoading} />
        {openManageDialog && (
          <UserPermissionDetailDialog
            user={selectedUser}
            open={openManageDialog}
            onClose={onManageClose}
            setSaveClickUpdate={setSaveClickUpdate}
          />
        )}

        {openCreateDialog && (
          <CreateUserDialog
            open={openCreateDialog}
            setOpen={setOpenCreateDialog}
            onClose={() => {
              setOpenCreateDialog(false)
            }}
            setSaveClickUpdate={setSaveClickUpdate}
          />
        )}
      </div>
    </Paper>
  )
}
